<div class="onboarding-container">
    <div class="onboarding-card">
        <div class="image-section">
            <img src="../../../../assets/images/pngs/jyotishlogo.png" alt="Shiva" class="main-image" />
            <!-- <img src="../../../../assets/images/brand/astro.png" alt="Logo" class="logo-overlay" /> -->
        </div>
        <div class="form-section">
            <h2 class="brand-title">JYOTISH MENTOR</h2>
            <p class="subtitle"> Welcome Admin</p>


            <form class="login100-form validate-form" [formGroup]="loginForm" (submit)="onLogin()">
                <!-- Email Field -->
                <div class="input-wrapper">
                    <input type="email" placeholder="Enter Email" class="mobile-input" formControlName="email" />
                </div>

                <div
                    *ngIf="loginForm.get('email')?.invalid && (loginForm.get('email')?.touched || loginForm.get('email')?.dirty)">
                    

                    <div class="mt-1 ms-1" style="text-align: left; color: red;">
                        Email is required.
                    </div>
                </div>

                <!-- Password Field -->
                <div class="input-wrapper">
                    <input [type]="showPassword" placeholder="Enter Password" class="mobile-input"
                        formControlName="password" />
                    <div class="d-flex justify-content-end text-success" (click)="toggelShowPassword(showPassword)">
                        @if (showPassword === 'text') {
                        <i class="bi bi-eye-slash"></i>
                        } @else {
                        <i class="bi bi-eye"></i>
                        }
                    </div>
                </div>

                <div
                    *ngIf="loginForm.get('password')?.invalid && (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)">
                    <div class=" mt-1 ms-1" style="text-align: left; color: red;">
                        Password is required.
                    </div>
                </div>

                <div class=" mt-2 g-recaptcha ">
                    <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (load)="handleLoad()"
                        (success)="handleSuccess($event)" [useGlobalDomain]="false" formControlName="recaptcha">
                    </ngx-recaptcha2>
                </div>

                <button class="otp-button" [disabled]="!loginForm.valid">SIGN IN</button>
            </form>
            <p class="terms">
                <a [routerLink]="['/forgot-password']" class="ml-1">Forgot
                    Password ?</a>
            </p>

        </div>
    </div>
</div>